import { useContext } from 'react';
import { AutomaticLogoutContext } from '../AutomaticLogoutContext';
import { AutomaticLogoutContextState } from '../model/AutomaticLogoutContextState';

export const useAutomaticLogoutContext = (): AutomaticLogoutContextState => useContext(AutomaticLogoutContext);
